var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBraveHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29397",
    "data-name": "Group 29397",
    transform: "translate(-556 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(556 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-brave",
    transform: "translate(574 349.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50170",
    "data-name": "Path 50170",
    d: "M15.64,12a6.64,6.64,0,1,0,6.64,6.64A6.64,6.64,0,0,0,15.64,12Z",
    transform: "translate(-6.787 -8.458)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50171",
    "data-name": "Path 50171",
    d: "M19.508,34H11.33A2.337,2.337,0,0,0,9,36.33v2.1H22.059l-.221-1.518V36.33A2.337,2.337,0,0,0,19.508,34Z",
    transform: "translate(-6.787 -20.719)",
    fill: "#00695c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50172",
    "data-name": "Path 50172",
    d: "M22.968,41.443v.885h-.885v-.885A.443.443,0,0,1,22.526,41h0A.443.443,0,0,1,22.968,41.443Zm-7.083,0v.885H15v-.885A.443.443,0,0,1,15.443,41h0A.443.443,0,0,1,15.885,41.443Z",
    transform: "translate(-10.13 -24.621)",
    fill: "#004d40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50173",
    "data-name": "Path 50173",
    d: "M21.427,27.421V26.106a8.875,8.875,0,0,1-2.656,0v1.315A2.394,2.394,0,0,1,17,29.613a4.025,4.025,0,0,0,3.1,1.315,4.025,4.025,0,0,0,3.1-1.315A2.4,2.4,0,0,1,21.427,27.421Z",
    transform: "translate(-11.245 -16.32)",
    fill: "#ffe0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50174",
    "data-name": "Path 50174",
    d: "M19.9,29.466c.443-.443.885-.885,3.119-1.086a1.8,1.8,0,0,1-.02-.208v-.719a3.763,3.763,0,0,1-2.656,0v.719a2.337,2.337,0,0,1-.521,1.37Z",
    transform: "translate(-12.819 -17.071)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50175",
    "data-name": "Path 50175",
    d: "M8.328,35a1.328,1.328,0,1,0,1.328,1.328A1.328,1.328,0,0,0,8.328,35Z",
    transform: "translate(-5.672 -21.277)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50176",
    "data-name": "Path 50176",
    d: "M6.435,26A2.435,2.435,0,1,0,8.87,28.435,2.435,2.435,0,0,0,6.435,26Z",
    transform: "translate(-4 -16.261)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50177",
    "data-name": "Path 50177",
    d: "M7.1,14a3.1,3.1,0,1,0,3.1,3.1A3.1,3.1,0,0,0,7.1,14Z",
    transform: "translate(-4 -9.573)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50178",
    "data-name": "Path 50178",
    d: "M11.656,6a2.656,2.656,0,1,0,2.656,2.656A2.656,2.656,0,0,0,11.656,6Z",
    transform: "translate(-6.787 -5.115)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50179",
    "data-name": "Path 50179",
    d: "M20.656,4a2.656,2.656,0,1,0,2.656,2.656A2.656,2.656,0,0,0,20.656,4Z",
    transform: "translate(-11.802 -4)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50180",
    "data-name": "Path 50180",
    d: "M25.656,5a2.656,2.656,0,1,0,2.656,2.656A2.656,2.656,0,0,0,25.656,5Z",
    transform: "translate(-14.589 -4.557)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50181",
    "data-name": "Path 50181",
    d: "M30.877,10a2.877,2.877,0,1,0,2.877,2.877A2.877,2.877,0,0,0,30.877,10Z",
    transform: "translate(-17.376 -7.344)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50182",
    "data-name": "Path 50182",
    d: "M33.877,19a2.877,2.877,0,1,0,2.877,2.877A2.877,2.877,0,0,0,33.877,19Z",
    transform: "translate(-19.047 -12.36)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50183",
    "data-name": "Path 50183",
    d: "M32.435,26a2.435,2.435,0,1,0,2.435,2.435A2.435,2.435,0,0,0,32.435,26Z",
    transform: "translate(-18.49 -16.261)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50184",
    "data-name": "Path 50184",
    d: "M36.771,33a1.771,1.771,0,1,0,1.771,1.771A1.771,1.771,0,0,0,36.771,33Z",
    transform: "translate(-21.277 -20.162)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50185",
    "data-name": "Path 50185",
    d: "M37.107,39a1.107,1.107,0,1,0,1.107,1.107A1.107,1.107,0,0,0,37.107,39Z",
    transform: "translate(-21.834 -23.506)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50186",
    "data-name": "Path 50186",
    d: "M22.607,14.376A2.479,2.479,0,0,0,20.416,13H17.328A4.409,4.409,0,0,0,16,16.32a3.43,3.43,0,0,0,3.541,3.32,3.43,3.43,0,0,0,3.541-3.32A4.19,4.19,0,0,0,22.607,14.376Z",
    transform: "translate(-10.688 -9.016)",
    fill: "#ffe0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50187",
    "data-name": "Path 50187",
    d: "M22.763,17a.664.664,0,1,0,.664.664A.664.664,0,0,0,22.763,17Zm-3.1,0a.664.664,0,1,0,.664.664A.664.664,0,0,0,19.664,17Z",
    transform: "translate(-12.36 -11.245)",
    fill: "#00838f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50188",
    "data-name": "Path 50188",
    d: "M24.213,24h-.885C22,24,22,24.443,22,24.443s0,.443.885.443A1.638,1.638,0,0,0,24.213,24Z",
    transform: "translate(-14.032 -15.146)",
    fill: "#ff8a65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraveHighlighted);
export default __webpack_public_path__ + "static/media/braveHighlighted.06ea0a9113496f32d929779c0d4459c3.svg";
export { ForwardRef as ReactComponent };